import type { ReactNode } from 'react';
import { BottomNav } from './BottomNav';

interface AppShellProps {
  children: ReactNode;
  hideNav?: boolean;
}

export function AppShell({ children, hideNav }: AppShellProps) {
  return (
    <div className="flex flex-col h-dvh max-w-lg mx-auto">
      <main className={`flex-1 flex flex-col min-h-0 ${hideNav ? '' : 'pb-nav-safe'}`}>
        {children}
      </main>
      {!hideNav && <BottomNav />}
    </div>
  );
}
